import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [
  {
    title: 'Reportes',
    path: '/reportes/portabilidad',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const ReportePortabilidadPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Portabilidad</PageTitle>
      <View />
    </>
  );
};

export { ReportePortabilidadPage };
